import { useCommon } from '../../Hooks/Common/useCommon';
import { useProdServiceBuildList } from '../../Hooks/Features/HelpDesk/useProdServiceBuildList';
import { MultiSelect } from 'primereact/multiselect';
import PanelHeaderTemplate from '../CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate';
import DatePicker from 'react-multi-date-picker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RequestPopup from './RequestPopup';
import { AgGridReact } from '@ag-grid-community/react';
import { SkeletonDataTable } from "../Loader/Loader";
import { Dialog } from 'primereact/dialog';
import { Calendar } from 'primereact/calendar';
import { useTheme } from '../../context/ThemeContext';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { dateConvert, timePickerMuiCss, timeStringToDate } from '../../utils/Helper';
import _ from "underscore";
import CommonFilterDropdown from '../CommonCompo/CommonFilterDropdown/CommonFilterDropdown';
const ProdServiceBuildList = () => {
  const { theme } = useTheme();
  const { tagRef, dropDownOption, filterValues, setFilterValues, showRequestPopup, setShowRequestPopup, editData, setEditData, getRequestedData, rowData, columnDef, handleStatusChange, loader, setCallJenkinsApi, showApprovePopup, setShowApprovePopup, approval, setApproval, handleApproveReject, viewPopup, setViewPopup, gridRef, onColumnMoved, onGridReady } = useProdServiceBuildList();
  const { checkPermission } = useCommon();

  return (
    <div ref={() => checkPermission("help desk", tagRef)}>
      <div ref={tagRef} id='{"tabname": "helpdesk", "data": "prod_service_build_tab"}' >
        <div className="row sk-header-row">
          <div className="col-md-6 col-12">
            <div className="row g-3">
              <div className="col-md-9 col-12">
                <CommonFilterDropdown
                  fields={[
                    { key: "projects", label: "Projects", col: 4},
                    { key: "all_users", label: "Users", col: 4 },
                    { key: "build_type", label: "Build Type", col: 4 }
                  ]}
                  filterValues={filterValues}
                  setFilterValues={setFilterValues} />
              </div>
              <div className="col-md-3 col-12 px-2">
                <MultiSelect
                  onChange={(e) => { setFilterValues((prev) => ({ ...prev, jenkins_type: e.target.value, isChange: true })) }}
                  options={dropDownOption?.jenkins_type}
                  filter filterInputAutoFocus
                  placeholder="Jenkins Type"
                  title="Jenkins Type"
                  onHide={() => { if (filterValues?.isChange) { getRequestedData(); setFilterValues((prev) => ({ ...prev, isChange: false })) } }}
                  value={filterValues?.jenkins_type} optionLabel="jenkins_type_name"
                  className="sk-multiselect"
                  panelClassName="sk-multiselect-panel"
                  panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'jenkins_type', filterValues?.jenkins_type, (val) => setFilterValues((prev) => ({ ...prev, jenkins_type: val })), () => { getRequestedData("jenkins_type") })} />
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-between align-items-center col-md-6 col-12">
            <div className='w30'>
              <DatePicker
                value={filterValues?.hoveredRange}
                onChange={(e) => { setFilterValues((prev) => ({ ...prev, hoveredRange: e, isChange: true })); }}
                range
                rangeHover
                placeholder="Select Date"
                onClose={() => { if (filterValues?.isChange && ((filterValues?.hoveredRange?.[0] && filterValues?.hoveredRange?.[1]) || (!filterValues?.hoveredRange?.[0] && !filterValues?.hoveredRange?.[1]))) { getRequestedData(); setFilterValues((prev) => ({ ...prev, isChange: false })) } }}
              />
            </div>
            <div className="d-flex align-items-center flex-wrap w55">
              {dropDownOption?.statusOptions?.map((item) => (
                <div
                  key={item.request_status_id}
                  className="d-flex justify-content-center align-items-center"
                >
                  <input
                    type="radio"
                    id={item.request_status_id}
                    name="status"
                    value={item.request_status_id}
                    onChange={(e) => handleStatusChange(e)}
                    checked={
                      filterValues?.status?.request_status_id ===
                      item.request_status_id
                    }
                    className="sk-radio"
                  />
                  <label htmlFor={item.request_status_id} className="sk-radio-label">
                    {item.request_status_name}
                  </label>
                </div>
              ))}
            </div>
            <div className='w15 d-flex gap-2 justify-content-end'>
              <button className="sk-btn sk-btn-primary" onClick={() => { getRequestedData() }}><FontAwesomeIcon icon="fa-solid fa-arrows-rotate" title="Refresh" /> </button>
              <button className="sk-btn sk-btn-primary" onClick={() => setShowRequestPopup(true)}><FontAwesomeIcon icon="fa-solid fa-plus" title="Add Request" /> </button>
            </div>
          </div>
        </div>

        <div className={`sk-ag-grid ${theme === 'dark' ? 'ag-theme-alpine-dark' : 'ag-theme-alpine'}`} style={{ height: "calc(100vh - 110px)" }}>
          {loader?.grid ? <SkeletonDataTable numSkeletons={20} /> :
            <AgGridReact columnDefs={_.sortBy(columnDef, "displayOrder")} rowData={rowData} rowHeight={30} ref={gridRef} onGridReady={onGridReady} onColumnMoved={onColumnMoved} />
          }
        </div>

        {
          showRequestPopup && <RequestPopup showRequestPopup={showRequestPopup} setShowRequestPopup={setShowRequestPopup} editData={editData} setEditData={setEditData} callApi={getRequestedData} type="prod_service_build_tab" />
        }

        <Dialog visible={showApprovePopup} header="Approve Request" onHide={() => { setShowApprovePopup(false); }} className="modal-xsmall" draggable={false}>
          <div className="" >
            <div className="mx-auto w70 inspectra-calendar">
              <span> Build Date Time</span>
              <div className='d-flex gap-1'>
                <Calendar className='input-dd' value={approval?.build_date} onChange={(e) => setApproval((prev) => ({ ...prev, build_date: timeStringToDate(dateConvert(approval?.build_date || new Date((new Date()).getTime() + 8 * 60000), "hour-min"), new Date(e.target.value)) }))} dateFormat='dd-mm-yy' placeholder="Select date" minDate={new Date((new Date()).getTime() + 8 * 60000)} />
                <TimePicker value={approval?.build_date || null} onChange={(e) => setApproval((prev) => ({ ...prev, build_date: timeStringToDate(dateConvert(e, "hour-min"), approval?.build_date || new Date()) }))} sx={{ ...timePickerMuiCss, backgroundColor: "white", margin: "2px 2px" }} minTime={new Date((new Date()).getTime() + 8 * 60000)}
                  slotProps={{
                    textField: {
                      label: undefined,
                      error: false
                    }
                  }}
                />
              </div>
            </div>
            <div className="d-flex gap-2 justify-content-center mt-2" >
              {loader?.btn ?
                <button className="sk-btn sk-btn-primary" style={{ width: "70px", height: "30px" }}>
                  <div className="spinner-border" role="status" style={{ width: "20px", height: "20px" }}>
                    <span className="sr-only"></span>
                  </div>
                </button> : <button className="sk-btn sk-btn-primary bg-black text-white" onClick={() => handleApproveReject("is_approved", null, "approve2")} > Confirm </button>
              }
              <button onClick={() => { setShowApprovePopup(false) }} className="sk-btn sk-btn-primary"> Cancel </button>
            </div>
          </div>
        </Dialog>

        <Dialog visible={viewPopup?.services} header="Services List" onHide={() => { setViewPopup((prev) => ({ ...prev, services: false, data: [] })); }} className="modal-small" draggable={false}>
          {viewPopup?.data?.map(item => (
            <div className='py-1 border-bottom'>{item}</div>
          ))}
        </Dialog>

        <Dialog visible={viewPopup?.reason} header="Reason / Release Notes" onHide={() => { setViewPopup((prev) => ({ ...prev, reason: false, data: [] })); }} className="modal-small" draggable={false}>
          {viewPopup?.data?.map(item => {
            const urlRegex = /(https?:\/\/[^\s]+)/g;

            return <div>
              {item?.split(urlRegex).map((part, index) => {
                if (part.match(urlRegex)) {
                  return (
                    <a key={index} href={part} target="_blank" className="text-primary" >{part}</a>
                  );
                }
                return part
              })}
            </div>
          })}
        </Dialog>
      </div>
    </div>
  )
}

export default ProdServiceBuildList